<template>
  <v-card flat class="pt-3 pb-4">
    <!-- Header Section -->
    <v-row class="px-4 py-2" align="center">
      <v-col cols="12" sm="6">
        <h2 class="text-h5 font-weight-bold grey--text text--darken-2">
          {{ report_title.title }}
        </h2>
        <div class="text-subtitle-2 grey--text">
          {{ report_title.is_default ? '' : report_title.union + report_title.origin + ' | ' + report_title.date_format }}
        </div>

      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <v-btn color="primary" depressed height="44" class="rounded-lg px-6" @click="show_filters = true">
          <v-icon left>search</v-icon>
          Consultar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filters Dialog -->
    <HeaderFiltersReports :open_dialog="show_filters" :filter_options="report_options[aging_type - 1]"
      @set_filters="set_filters" :loading="loading" />

    <!-- Summary Statistics Section -->
    <v-container fluid class="mt-4">
      <v-row>
        <!-- Total Entities Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl pa-4 elevation-1 border-light">
            <div class="d-flex align-center mb-2">
              <v-avatar color="blue lighten-5" size="40" class="mr-3">
                <v-icon color="blue">{{ aging_type == 1 ? 'conveyor_belt' : 'people' }}</v-icon>
              </v-avatar>
              <span class="text-caption font-weight-medium grey--text text-uppercase letter-spacing-1">
                Total {{ aging_type == 1 ? 'Suplidores' : 'Clientes' }}
              </span>
            </div>
            <div class="text-h4 font-weight-black primary--text">
              {{ resume_report.totals.length == 0 ? 0 : resume_report.customers }}
            </div>
          </v-card>
        </v-col>

        <!-- Dynamic Totals per Currency -->
        <v-col v-for="item in resume_report.totals" :key="item.currency_code" cols="12" sm="6" md="3">
          <v-card class="rounded-xl pa-4 elevation-1 border-light glass-effect">
            <div class="d-flex align-center mb-2">
              <v-avatar color="green lighten-5" size="40" class="mr-3">
                <v-icon color="green">payments</v-icon>
              </v-avatar>
              <span class="text-caption font-weight-medium grey--text text-uppercase letter-spacing-1">
                Total {{ item.currency_code }}
              </span>
            </div>
            <div class="text-h4 font-weight-black grey--text text--darken-3">
              <span class="text-subtitle-2 font-weight-bold">$</span>{{ currencyFormat(item.amount) }}
            </div>
          </v-card>
        </v-col>

        <!-- Grand Total Base Currency Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl pa-4 elevation-2 primary darken-1 white--text">
            <div class="d-flex align-center mb-2">
              <v-avatar color="white opacity-20" size="40" class="mr-3">
                <v-icon color="white">account_balance_wallet</v-icon>
              </v-avatar>
              <span class="text-caption font-weight-medium white--text text-uppercase letter-spacing-1 opacity-80">
                Total Moneda Base
              </span>
            </div>
            <div class="text-h4 font-weight-black">
              <span class="text-subtitle-2 font-weight-bold">$</span>{{ currencyFormat(resume_report.gran_total) }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Export Actions Group -->
      <v-row v-show="report_data.length > 0" class="mt-4">
        <v-col cols="12" class="text-right pb-0">
          <v-menu offset-y transition="slide-y-transition" bottom left min-width="240">
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="success" depressed height="44" class="rounded-lg px-6" v-bind="attrs" v-on="on">
                <v-icon left>download</v-icon>
                Exportar Reporte
                <v-icon right small>expand_more</v-icon>
              </v-btn>
            </template>
            <v-list class="py-2 rounded-lg elevation-4">
              <v-list-item @click="generate_excel_detail()" class="px-4">
                <v-list-item-icon class="mr-3">
                  <v-icon color="success">assignment_turned_in</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">Detallado en Excel</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">Desglose por factura</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="generate_excel_resume()" class="px-4">
                <v-list-item-icon class="mr-3">
                  <v-icon color="success">assessment</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">Resumido en Excel</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">Resumen por entidad</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider v-if="aging_type == 2" class="my-1"></v-divider>

              <v-list-item v-if="aging_type == 2" @click="get_customer_account_statement()" class="px-4">
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">account_balance</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium primary--text">Estado de Cuenta</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">Reporte para clientes</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import moment from "moment";
import ExcelJS from "exceljs";
import HeaderFiltersReports from "@/components/Accounting/HeaderFiltersReports.vue";
export default {
  data: () => ({
    loading: false,
    show_filters: false,
    report_filters: null,
    report_data: [],
    resume_report: { totals: [], gran_total: 0 },
    report_options: [
      { show_calendar: false, show_date_range: false, show_date_type: true, show_supplier_type: true, show_language_type: true, show_customer_type: false, entity_type: 1/*cliente*/ },//CXP
      { show_calendar: false, show_date_range: false, show_date_type: true, show_supplier_type: false, show_language_type: true, show_customer_type: true, entity_type: 2/*suplidor*/ },//CXC
    ],
  }),
  name: "AgingReportsvue.vue",
  props: {
    aging_type: {
      type: Number,
      default: 1,//1:COMPRAS=CXP, 2:VENTAS=CXC
    },
  },
  mounted() {

  },
  computed: {
    report_title() {
      let name = {
        title: 'INFORME DE ENVEJECIMIENTO DE CUENTAS POR ' + (this.aging_type == 1 ? 'PAGAR' : 'COBRAR'),
        date: moment().format("YYYY-MM-DD"),
        date_format: moment().format("DD/MM/YYYY"),
        origin: '',
        union: ' DE ',
        is_default: true
      };
      if (this.report_filters == null) {
        return name;
      }
      name.is_default = false;
      name.date = this.report_filters.filters.dateEnd;
      name.date_format = moment(this.report_filters.filters.dateEnd).format("DD/MM/YYYY");
      if (this.report_filters.filters.language == 'en') {
        name.title = `ACCOUNTS ${this.aging_type == 1 ? 'PAYABLE' : 'RECEIVABLE'} AGING REPORT`;
        name.union = ' OF ';
      }
      if (this.report_filters.filters.location != null) {
        name.origin = this.report_filters.filters.location.text;
        return name
      }
      if (this.report_filters.filters.business_unit != null) {
        name.origin = this.report_filters.filters.business_unit.text;
        return name
      }
      return name
    }
  },
  methods: {
    set_filters(res) {
      if (!res.response) {
        this.show_filters = false;
        return
      }
      this.generate_report(res);
    },
    async generate_report(response) {
      const filters = response.filters;
      try {
        this.loading = true;
        let result = await this.api_Post("accounting/aigin_report",
          {
            location_id: filters.location ? filters.location.id : this.$store.state.auth.user.acess_locations.toString(),
            business_units: filters.business_unit.id,
            currency_type: filters.currency_type,
            include_currency_id: filters.currency_type == 2 && filters.currency.id != 0 ? true : false,
            currency_id: filters.currency.id,
            currency_code: filters.currency.code,
            report_type: this.aging_type==2?'2,3': '1,4',
            date_type: filters.date_type.value,
            effective_date: filters.dateEnd,
            customer_type: filters.customer_type.id,
            entity_id: filters.entity != null ? filters.entity.entity_id : null
          }
        );
        if (result.status == 200) {
          const data = await result.json();
          if (data.length > 0) {
            this.report_data = data;
            this.report_filters = response;
            this.calculate_resume();
            this.show_filters = false;
            this.loading = false;
            return
          }
          this.$toast.info('No hay datos para generar el reporte');
        }
        this.loading = false;
      } catch (error) {
        console.error(error.message);
        this.loading = false;
      }
    },
    calculate_resume() {
      let customers = [], current_currency = this.report_data[0].currency_id;
      let totals = [{ currency_code: this.report_data[0].currency_code, amount: 0 }];
      let gran_total = 0;

      for (let item of this.report_data) {
        if (!customers.includes(item.original_entity_id)) {
          customers.push(item.original_entity_id)
        }
        if (item.currency_id != current_currency) {
          totals.push({ currency_code: item.currency_code, amount: parseFloat(item.total_amount) })
          current_currency = item.currency_id;
          continue
        }
        totals[totals.length - 1].amount += parseFloat(item.total_amount)
      }

      for (let currency of totals) {
        const currency_rate = this.report_filters.currencies.find((element) => element.code == currency.currency_code);
        gran_total += currency.amount / parseFloat(currency_rate.value)
      }
      this.resume_report = {
        totals: totals,
        customers: customers.length,
        gran_total: gran_total
      }
    },
    async generate_excel_detail() {
    const data = this.report_data;
    const response = this.report_filters;
    const language = response.filters.language;
    const currency_rates = response.currencies;
    const due_days_range = response.filters.due_days.range;
    const accountingFormat = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
    const titles = {
        es: {
            date_to: "A FECHA DE",
            currency_id: "MONEDA DE TRANSACCION",
            business_unit_id: "UNIDAD DE NEGOCIO",
            location_id: "UBICACION",
            entity_id: "CLIENTE",
            type: "TIPO DE FACTURA",
            invoice: "NUMERO DE FACTURA",
            manifest: "FACTURA DE SUPLIDOR",
            date: "FECHA DE FACTURA",
            account_date: "FECHA CONTABLE",
            due_days: "DIAS DE VENCIMIENTO",
            total: "TOTAL",
            days: "DIAS",
            general_total: 'TOTAL GENERAL A LA MONEDA BASE',
            total_of: 'TOTAL DE %',
            over: 'SOBRE'
        },
        en: {
            date_to: "AS OF DATE",
            currency_id: "TRANSACTION CURRENCY",
            business_unit_id: "BUSINESS UNIT",
            location_id: "LOCATION",
            entity_id: "CUSTOMER",
            type: "INVOICE TYPE",
            invoice: "INVOICE NUMBER",
            manifest: "SUPPLIER NUMBER",
            date: "INVOICE DATE",
            account_date: "ACCOUNTING DATE",
            due_days: "DUE DAYS",
            total: "TOTAL",
            days: "DAYS",
            general_total: 'BASE CURRENCY GENERAL TOTAL',
            total_of: '% TOTAL',
            over: 'OVER'
        }
    };
    const excel_title = `${this.report_title.title} ${this.report_title.union} ${this.report_title.origin} ${this.report_title.date}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Aging');

    const titleA = worksheet.insertRow(1, ['GRUPO M']);
    worksheet.mergeCells('A1:K1');
    titleA.getCell(1).font = { size: 16, bold: true };
    titleA.getCell(1).alignment = { horizontal: 'center' };

    const titleB = worksheet.insertRow(2, [this.report_title.title]);
    worksheet.mergeCells('A2:K2');
    titleB.getCell(1).font = { size: 16, bold: true };
    titleB.getCell(1).alignment = { horizontal: 'center' };

    const date_type = language == 'es' ? response.filters.date_type.text : response.filters.date_type.en;
    const titleDate = worksheet.insertRow(3, [`${titles[language].date_to} ${moment(response.filters.dateEnd).format("DD/MM/YYYY")} (${date_type})`]);
    worksheet.mergeCells('A3:K3');
    titleDate.getCell(1).font = { size: 16, bold: true };
    titleDate.getCell(1).alignment = { horizontal: 'center' };
    let row = 4;

    // PRE-CALCULA TOTALES POR ENTIDAD PARA SABER CUÁLES TIENEN SALDO 0
    const entity_totals = {};
    for (let item of data) {
        if (!entity_totals[item.entity_id]) {
            entity_totals[item.entity_id] = 0;
        }
        entity_totals[item.entity_id] += parseFloat(item.total_amount);
        if (item.payments != null) {
            for (let payment of item.payments) {
                entity_totals[item.entity_id] -= parseFloat(payment.total_amount);
            }
        }
        if (item.adjustment != null) {
            for (let adjustment of item.adjustment) {
                entity_totals[item.entity_id] += parseFloat(adjustment.total_amount) * (adjustment.invoice_type_id == 10 ? -1 : 1);
            }
        }
    }

    //TITULOS INICIALES
    set_headers(titles[language].currency_id, data[0].currency_code);
    set_headers(titles[language].business_unit_id, data[0].business_unit_description);
    set_headers(titles[language].location_id, data[0].location_description);
    set_headers(titles[language].entity_id, data[0].entity_name);
    set_columns();

    //LINEA INICIAL
    let current_data = {
        currency_id: data[0].currency_id,
        business_unit_id: data[0].business_unit_id,
        location_id: data[0].location_id,
        invoice_id: data[0].invoice_id,
        entity_id: data[0].entity_id,
        currency_code: data[0].currency_code
    };

    //GENERA LAS LINEAS DE TITULOS
    function set_headers(title, data) {
        const line = worksheet.insertRow(row, [`${title}: ${data}`]);
        worksheet.mergeCells(`A${row}:K${row}`);
        line.getCell(1).font = { size: 14, bold: true };
        line.getCell(1).alignment = { horizontal: 'left' };
        line.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D3D3D3' } };
        row++;
    }

    //DETERMINA EL TITULO DE LAS COLUMNAS DE LOS DIAS DE VENCIMIENTO
    function get_due_day_range_text(range) {
        const ranges = [
            '0 - ' + due_days_range[range],
            (due_days_range[range - 1] + 1) + ' - ' + due_days_range[range],
            (due_days_range[range - 1] + 1) + ' - ' + due_days_range[range],
            `${titles[language].over} ${due_days_range[range - 1] + 1}`,
        ];
        return `${ranges[range]} ${titles[language].days}`;
    }

    //GENERA LA LINEA TITULOS DE LAS COLUMNAS SEGUN EL IDIOMA
    function set_columns() {
        const cols = [titles[language].type, titles[language].invoice, titles[language].manifest, titles[language].date, titles[language].account_date, titles[language].due_days, titles[language].total, get_due_day_range_text(0), get_due_day_range_text(1), get_due_day_range_text(2), get_due_day_range_text(3)];
        const columns = worksheet.insertRow(row, cols);
        for (let col = 1; col <= cols.length; col++) {
            columns.getCell(col).font = { size: 12, bold: true };
        }
        row++;
    }

    //DETERMINA EL TIPO DE LA LINEA
    function get_type(tp, invoice_tp) {
        if (tp == 0) {
            return 'PAGO';
        }
        const types = {
            es: {
                1: 'FACTURA DE COMPRA',
                2: 'FACTURA DE VENTA',
                3: 'DOCUMENTO INTERNO POR COBRAR',
                4: 'DOCUMENT INTERNO POR PAGAR',
                10: 'NOTA CREDITO',
                11: 'NOTA DEBITO'
            },
            en: {
                1: 'PURCHASE INVOICE',
                2: 'SALES INVOICE',
                3: 'INTERNAL DOCUMENT TO BE COLLECTED',
                4: 'INTERNAL DOCUMENT TO BE PAID',
                10: 'CREDIT NOTE',
                11: 'DEBIT NOTE'
            }
        };
        return types[language][invoice_tp];
    }

    //SEGUN LOS DIAS DE VENCIMIENTO DETERMINA EN LA COLUMNA QUE DEBE IMPRIMIR
    function validate_due_days_to_colum(data, array_row, x) {
        let count = 1;
        for (let day of due_days_range) {
            let amount = 0;
            if (data.days <= day) {
                amount = parseFloat(data.total_amount) * x;
                array_row.push(amount);
                totals.entity_id[count] += amount;
                totals.location_id[count] += amount;
                totals.business_unit_id[count] += amount;
                totals.currency_id[count] += amount;
                return { array: array_row, amount: amount };
            }
            count++;
            array_row.push('');
            if (day == due_days_range[due_days_range.length - 1] && data.days > due_days_range[due_days_range.length - 1]) {
                amount = parseFloat(data.total_amount) * x;
                array_row.push(amount);
                totals.entity_id[count] += amount;
                totals.location_id[count] += amount;
                totals.business_unit_id[count] += amount;
                totals.currency_id[count] += amount;
                return { array: array_row, amount: amount };
            }
        }
    }

    let totals = {
        currency_id: { level: 1, 1: 0, 2: 0, 3: 0, 4: 0, total: 0 },
        business_unit_id: { level: 2, 1: 0, 2: 0, 3: 0, 4: 0, total: 0 },
        location_id: { level: 3, 1: 0, 2: 0, 3: 0, 4: 0, total: 0 },
        entity_id: { level: 4, 1: 0, 2: 0, 3: 0, 4: 0, total: 0 },
    };
    let base_totals = { 1: 0, 2: 0, 3: 0, 4: 0, total: 0 };

    function compare_rows(new_row, compare, property, set_column, print) {
        if (current_data[compare] != new_row[compare] || print) {
            set_headers(titles[language][compare], new_row[property]);
            current_data[compare] = new_row[compare];
            current_data.currency_code = new_row.currency_code;
            if (set_column) {
                set_columns();
            }
        }
    }

    function get_porcentage(amount, total) {
        if (Math.abs(total) < 0.01) return 0;
        return ((amount / total) * 100);
    }

    function set_total(new_row, compare, is_final_row) {
        if (current_data[compare] != new_row[compare] || is_final_row) {

            // SOLO IMPRIME SI EL TOTAL ES SIGNIFICATIVO
            if (Math.abs(totals[compare].total) >= 0.01) {
                let total_cols = [`${titles[language].total_of.replace('%', titles[language][compare])}: ${current_data.currency_code}`, '', '', '', '', '', Math.round(totals[compare].total * 100) / 100];
                for (let col = 1; col <= 4; col++) {
                    total_cols.push(Math.round(totals[compare][col] * 100) / 100);
                }
                const newTotal = worksheet.insertRow(row, total_cols);
                worksheet.mergeCells(`A${row}:F${row}`);
                newTotal.getCell(1).font = { size: 14, bold: true };
                newTotal.getCell(1).alignment = { horizontal: 'right' };
                newTotal.eachCell((cell, colNumber) => {
                    if (colNumber > 6) {
                        cell.numFmt = accountingFormat;
                        cell.font = { size: 12, bold: true };
                        cell.border = {
                            bottom: { style: 'double', color: { argb: 'black' } },
                        };
                    }
                });
                row++;

                //---------------------------------------PORCENTAJES-----------------------------------------------------
                let row_data = [`% `, '', '', '', '', '', get_porcentage(totals[compare].total, totals[compare].total)];
                for (let col = 1; col <= 4; col++) {
                    row_data.push(get_porcentage(totals[compare][col], totals[compare].total));
                }
                const newPorcentage = worksheet.insertRow(row, row_data);
                worksheet.mergeCells(`A${row}:F${row}`);
                newPorcentage.getCell(1).font = { size: 14, bold: true };
                newPorcentage.getCell(1).alignment = { horizontal: 'right' };
                newPorcentage.eachCell((cell, colNumber) => {
                    if (colNumber > 6) {
                        cell.numFmt = '0.00\\%';
                        cell.font = { size: 12, bold: true };
                    }
                });
                row++;
            }

            // SIEMPRE SE EJECUTA: RESET DE TOTALES Y CÁLCULO DE BASE_TOTALS
            const currency_rate = currency_rates.find((element) => element.code == current_data.currency_code);
            for (let col = 1; col <= 4; col++) {
                if (compare == 'currency_id') {
                    base_totals[col] += (totals.currency_id[col]) / parseFloat(currency_rate.value);
                    base_totals.total += (totals.currency_id[col]) / parseFloat(currency_rate.value);
                    totals.business_unit_id[col] = 0;
                    totals.business_unit_id.total = 0;
                }
                totals[compare][col] = 0;
            }
            totals[compare].total = 0;
        }
    }

    let count = 1;
    //----------------------------------------------------------------------------------------
    for (let item of data) {

        // SI EL CLIENTE TIENE SALDO ~0, SALTA TODAS SUS LÍNEAS
        if (Math.abs(entity_totals[item.entity_id]) < 0.01) {
            if (current_data.entity_id != item.entity_id) {
                current_data.entity_id = item.entity_id;
            }
            if (current_data.location_id != item.location_id) {
                current_data.location_id = item.location_id;
            }
            if (current_data.business_unit_id != item.business_unit_id) {
                current_data.business_unit_id = item.business_unit_id;
            }
            if (current_data.currency_id != item.currency_id) {
                current_data.currency_id = item.currency_id;
                current_data.currency_code = item.currency_code;
            }
            if (count == data.length) {
                set_total(item, 'entity_id', true);
                set_total(item, 'location_id', true);
                set_total(item, 'business_unit_id', true);
                set_total(item, 'currency_id', true);
            }
            count++;
            continue;
        }

        //IMPRIME LOS TOTALES CUANDO CAMBIA
        set_total(item, 'entity_id', false);
        set_total(item, 'location_id', false);
        set_total(item, 'business_unit_id', false);
        set_total(item, 'currency_id', false);
        //IMPRIME LOS HEADERS CUANDO CAMBIA
        compare_rows(item, 'currency_id', 'currency_code', false, false);
        compare_rows(item, 'business_unit_id', 'business_unit_description', false, false);
        compare_rows(item, 'location_id', 'location_description', false, false);
        compare_rows(item, 'entity_id', 'entity_name', true, false);

        //IMPRIME LA LINEA DE LA FACTURA
        let invoices = [get_type(1, item.invoice_type_id), item.invoice_number, item.supplier_invoice_number || ' ', moment(item.emission_date).format("DD/MM/YYYY"), moment(item.account_date).format("DD/MM/YYYY"), item.days < 0 ? 0 : item.days, parseFloat(item.total_amount)];

        const response_row = validate_due_days_to_colum(item, invoices, 1);
        invoices = response_row.array;
        totals.entity_id.total += response_row.amount;
        totals.location_id.total += response_row.amount;
        totals.business_unit_id.total += response_row.amount;
        totals.currency_id.total += response_row.amount;

        const newRow = worksheet.insertRow(row, invoices);
        newRow.eachCell((cell, colNumber) => {
            if (colNumber > 6) {
                cell.numFmt = accountingFormat;
            }
        });

        //IMPRIME LOS PAGOS
        if (item.payments != null) {
            for (let payment of item.payments) {
                row++;
                let payment_array = [get_type(0, 0), item.invoice_number, item.supplier_invoice_number || ' ', moment(payment.payment_date).format("DD/MM/YYYY"), moment(payment.account_date).format("DD/MM/YYYY"), payment.days < 0 ? 0 : payment.days, parseFloat(payment.total_amount) * -1];

                const response_row = validate_due_days_to_colum(payment, payment_array, -1);
                payment_array = response_row.array;
                totals.entity_id.total += response_row.amount;
                totals.location_id.total += response_row.amount;
                totals.business_unit_id.total += response_row.amount;
                totals.currency_id.total += response_row.amount;
                const newPayment = worksheet.insertRow(row, payment_array);

                newPayment.eachCell((cell, colNumber) => {
                    if (colNumber > 6) {
                        cell.numFmt = accountingFormat;
                    }
                });
            }
        }

        //IMPRIME NOTAS DE CREDITO Y DEBITO
        if (item.adjustment != null) {
            for (let adjustment of item.adjustment) {
                row++;
                let debit_or_credit_array = [get_type(1, adjustment.invoice_type_id), item.invoice_number, item.supplier_invoice_number || ' ', moment(adjustment.emission_date).format("DD/MM/YYYY"), moment(adjustment.account_date).format("DD/MM/YYYY"), adjustment.days < 0 ? 0 : adjustment.days, parseFloat(adjustment.total_amount) * (adjustment.invoice_type_id == 10 ? -1 : 1)];

                const response_row = validate_due_days_to_colum(adjustment, debit_or_credit_array, adjustment.invoice_type_id == 10 ? -1 : 1);
                debit_or_credit_array = response_row.array;
                totals.entity_id.total += response_row.amount;
                totals.location_id.total += response_row.amount;
                totals.business_unit_id.total += response_row.amount;
                totals.currency_id.total += response_row.amount;
                const newDebitOrCredit = worksheet.insertRow(row, debit_or_credit_array);

                newDebitOrCredit.eachCell((cell, colNumber) => {
                    if (colNumber > 6) {
                        cell.numFmt = accountingFormat;
                    }
                });
            }
        }
        row++;
        if (count == data.length) {
            set_total(item, 'entity_id', true);
            set_total(item, 'location_id', true);
            set_total(item, 'business_unit_id', true);
            set_total(item, 'currency_id', true);
        }
        count++;
    }

    let total_cols = [
        `${titles[language].general_total}:`, '', '', '', '', '',
        Math.round(base_totals.total * 100) / 100,
        Math.round(base_totals[1] * 100) / 100,
        Math.round(base_totals[2] * 100) / 100,
        Math.round(base_totals[3] * 100) / 100,
        Math.round(base_totals[4] * 100) / 100
    ];
    row = row + 2;
    const newTotal = worksheet.insertRow(row, total_cols);
    worksheet.mergeCells(`A${row}:F${row}`);
    newTotal.getCell(1).font = { size: 14, bold: true };
    newTotal.getCell(1).alignment = { horizontal: 'right' };
    newTotal.eachCell((cell, colNumber) => {
        if (colNumber > 6) {
            cell.numFmt = accountingFormat;
            cell.font = { size: 12, bold: true };
            cell.border = {
                bottom: { style: 'double', color: { argb: 'black' } },
            };
        }
    });
    row++;
    let total_porcent_cols = [`%:`, '', '', '', '', '', get_porcentage(base_totals.total, base_totals.total), get_porcentage(base_totals[1], base_totals.total), get_porcentage(base_totals[2], base_totals.total), get_porcentage(base_totals[3], base_totals.total), get_porcentage(base_totals[4], base_totals.total)];
    const newTotalPorcentage = worksheet.insertRow(row, total_porcent_cols);
    worksheet.mergeCells(`A${row}:F${row}`);
    newTotalPorcentage.getCell(1).font = { size: 14, bold: true };
    newTotalPorcentage.getCell(1).alignment = { horizontal: 'right' };
    newTotalPorcentage.eachCell((cell, colNumber) => {
        if (colNumber > 6) {
            cell.numFmt = '0.00\\%';
            cell.font = { size: 12, bold: true };
        }
    });

    // Write the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = excel_title + ".xlsx";
    link.click();
},
    async generate_excel_resume() {
      let data = [];
      const response = this.report_filters
      const language = response.filters.language;
      const currency_rates = response.currencies;
      const due_days_range = response.filters.due_days.range;

      data = Object.values(this.report_data.reduce((acc, curr) => {
        const entityId = curr.entity_id;
        const days = curr.days;

        // Calcular el monto neto
        let netAmount = parseFloat(curr.total_amount) - parseFloat(curr.payment_amount || 0);

        // Restar el ajuste si existe
        if (curr.adjustment) {
          curr.adjustment.forEach(adj => {
            netAmount -= parseFloat(adj.total_amount);
          });
        }

        // Determinar el índice basado en "days"
        let index = due_days_range.findIndex(range => days <= range);
        if (index === -1) index = due_days_range.length; // Si "days" es mayor al último rango

        // Si el entity_id ya existe en el acumulador, sumar el netAmount al arreglo correspondiente
        if (acc[entityId]) {
          acc[entityId].amounts[index] += netAmount;
        } else {
          // Si no existe, crear una nueva entrada para el entity_id
          acc[entityId] = {
            currency_id: curr.currency_id,
            currency_code: curr.currency_code,
            business_unit_id: curr.business_unit_id,
            business_unit_description: curr.business_unit_description,
            location_id: curr.location_id,
            location_description: curr.location_description,
            original_entity_id: curr.original_entity_id,
            invoice_id: curr.invoice_id,
            invoice_type_id: curr.invoice_type_id,
            entity_id: entityId,
            entity_name: curr.entity_name.toUpperCase(),
            amounts: Array(due_days_range.length + 1).fill(0)
          };
          acc[entityId].amounts[index] = netAmount;
        }

        return acc;
      }, {}));

      function ordenarObjetos(arregloObjetos) {
        arregloObjetos.sort((a, b) => {
          // Comparación por currency_code
          if (a.currency_code !== b.currency_code) {
            return a.currency_code.localeCompare(b.currency_code);
          }

          // Comparación por business_unit_id
          if (a.business_unit_id !== b.business_unit_id) {
            return a.business_unit_id - b.business_unit_id;
          }

          // Comparación por location_id
          return a.location_id.localeCompare(b.location_id);
        });

        return arregloObjetos;
      }
      data = ordenarObjetos(data);
      const accountingFormat = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
      const titles = {
        es: {
          date_to: "A FECHA DE",
          currency_id: "MONEDA DE TRANSACCION",
          business_unit_id: "UNIDAD DE NEGOCIO",
          location_id: "UBICACION",
          entity_id: "CLIENTE",
          type: "TIPO DE FACTURA",
          invoice: "NUMERO DE FACTURA",
          manifest: "FACTURA DE SUPLIDOR",
          date: "FECHA DE FACTURA",
          account_date: "FECHA CONTABLE",
          due_days: "DIAS DE VENCIMIENTO",
          total: "TOTAL",
          days: "DIAS",
          general_total: 'TOTAL GENERAL A LA MONEDA BASE',
          total_of: 'TOTAL DE %',
          over: 'SOBRE'
        },
        en: {
          date_to: "AS OF DATE",
          currency_id: "TRANSACTION CURRENCY",
          business_unit_id: "BUSINESS UNIT",
          location_id: "LOCATION",
          entity_id: "CUSTOMER",
          type: "INVOICE TYPE",
          invoice: "INVOICE NUMBER",
          manifest: "SUPPLIER NUMBER",
          date: "INVOICE DATE",
          account_date: "ACCOUNTING DATE",
          due_days: "DUE DAYS",
          total: "TOTAL",
          days: "DAYS",
          general_total: 'BASE CURRENCY GENERAL TOTAL',
          total_of: '% TOTAL',
          over: 'OVER'
        }
      }
      const excel_title = `${this.report_title.title} ${this.report_title.union} ${this.report_title.origin} ${this.report_title.date}`;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Aging');

      const titleA = worksheet.insertRow(1, ['GRUPO M']);
      worksheet.mergeCells('A1:F1');
      titleA.getCell(1).font = { size: 16, bold: true };
      titleA.getCell(1).alignment = { horizontal: 'center' };

      const titleB = worksheet.insertRow(2, [this.report_title.title]);
      worksheet.mergeCells('A2:F2');
      titleB.getCell(1).font = { size: 16, bold: true };
      titleB.getCell(1).alignment = { horizontal: 'center' };

      const date_type = language == 'es' ? response.filters.date_type.text : response.filters.date_type.en;
      const titleDate = worksheet.insertRow(3, [`${titles[language].date_to} ${moment(response.filters.dateEnd).format("DD/MM/YYYY")} (${date_type})`]);
      worksheet.mergeCells('A3:F3');
      titleDate.getCell(1).font = { size: 16, bold: true };
      titleDate.getCell(1).alignment = { horizontal: 'center' };
      let row = 4;
      //TITULOS INICIALES
      set_headers(titles[language].currency_id, data[0].currency_code);
      set_headers(titles[language].business_unit_id, data[0].business_unit_description);
      set_headers(titles[language].location_id, data[0].location_description);
      // set_headers(titles[language].entity_id,data[0].entity_name);
      set_columns();

      //LINEA INICIAL
      let current_data = {
        currency_id: data[0].currency_id,
        business_unit_id: data[0].business_unit_id,
        location_id: data[0].location_id,
        invoice_id: data[0].invoice_id,
        entity_id: data[0].entity_id,
        currency_code: data[0].currency_code
      }
      //GENERA LAS LINEAS DE TITULOS
      function set_headers(title, data) {
        const line = worksheet.insertRow(row, [`${title}: ${data}`]);
        worksheet.mergeCells(`A${row}:F${row}`);
        line.getCell(1).font = { size: 14, bold: true };
        line.getCell(1).alignment = { horizontal: 'left' };
        line.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D3D3D3' } };
        row++
      }
      //DETERMINA EL TITULO DE LAS COLUMNAS DE LOS DIAS DE VENCIMIENTO, EJEMPLO: 0 - 30 DIAS
      function get_due_day_range_text(range) {
        const ranges = [
          '0 - ' + due_days_range[range],
          (due_days_range[range - 1] + 1) + ' - ' + due_days_range[range],
          (due_days_range[range - 1] + 1) + ' - ' + due_days_range[range],
          `${titles[language].over} ${due_days_range[range - 1] + 1}`,
        ]
        return `${ranges[range]} ${titles[language].days}`;
      }
      //GENERA LA LINEA TITULOS DE LAS COLUMNAS SEGUN EL IDIOMA
      function set_columns() {
        let cols = [];
        cols = [titles[language].entity_id, titles[language].total, get_due_day_range_text(0), get_due_day_range_text(1), get_due_day_range_text(2), get_due_day_range_text(3)]

        const columns = worksheet.insertRow(row, cols);
        for (let col = 1; col <= cols.length; col++) {
          columns.getCell(col).font = { size: 12, bold: true };
        }
        row++;
      }

      let totals = {
        currency_id: {
          level: 1,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          total: 0
        },
        business_unit_id: {
          level: 2,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          total: 0
        },
        location_id: {
          level: 3,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          total: 0
        },
        entity_id: {
          level: 4,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          total: 0
        },
      };
      let base_totals = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        total: 0
      }

      function compare_rows(new_row, compare, property, set_column, print) {
        if (current_data[compare] != new_row[compare] || print) {
          set_headers(titles[language][compare], new_row[property]);
          current_data[compare] = new_row[compare];
          current_data.currency_code = new_row.currency_code;
          if (set_column) {
            set_columns();
          }
        }
      }
      function get_porcentage(amount, total) {
          if (Math.abs(total) < 0.01) return 0;
          return ((amount / total) * 100);
      }

      function set_total(new_row, compare, is_final_row) {
        if (current_data[compare] != new_row[compare] || is_final_row) {
              let total_cols = [
                  `${titles[language].total_of.replace('%', titles[language][compare])}: ${current_data.currency_code}`,
                  '', '', '', '', '',
                  Math.round(totals[compare].total * 100) / 100
              ];
              for (let col = 1; col <= 4; col++) {
                  total_cols.push(Math.round(totals[compare][col] * 100) / 100);
              }

          const newTotal = worksheet.insertRow(row, total_cols);
          newTotal.getCell(1).font = { size: 14, bold: true };
          newTotal.getCell(1).alignment = { horizontal: 'right' };
          newTotal.eachCell((cell, colNumber) => {
            if (colNumber > 1) {
              cell.numFmt = accountingFormat;
              cell.font = { size: 12, bold: true };
              cell.border = {
                bottom: { style: 'double', color: { argb: 'black' } },
              }
            }
          });



          row++;

          //---------------------------------------PORCENTAJES-----------------------------------------------------
          let row_data = []
          row_data = [`% `, get_porcentage(totals[compare].total, totals[compare].total)];
          for (let col = 1; col <= 4; col++) {
            row_data.push(get_porcentage(totals[compare][col], totals[compare].total)); //SE VA AGREGANDO CADA COLUMNA DE PORCENTAJE
          }
          const newPorcentage = worksheet.insertRow(row, row_data)
          newPorcentage.getCell(1).font = { size: 14, bold: true };
          newPorcentage.getCell(1).alignment = { horizontal: 'right' };
          newPorcentage.eachCell((cell, colNumber) => {
            if (colNumber > 1) {
              cell.numFmt = '0.00\\%';
              cell.font = { size: 12, bold: true };
            }
          });

          row++;
          const currency_rate = currency_rates.find((element) => element.code == current_data.currency_code);
          for (let col = 1; col <= 4; col++) {
            if (compare == 'currency_id') {
              base_totals[col] += (totals.currency_id[col]) / parseFloat(currency_rate.value);
              base_totals.total += (totals.currency_id[col]) / parseFloat(currency_rate.value);
              totals.business_unit_id[col] = 0;
              totals.business_unit_id.total = 0;
            }
            totals[compare][col] = 0;
          }
          totals[compare].total = 0;
        }
      }
      let count = 1;
      //----------------------------------------------------------------------------------------
      for (let item of data) {

        //IMPRIME LOS TOTALES CUANDO CAMBIA
        //set_total(item,'entity_id',false);
        set_total(item, 'location_id', false);
        set_total(item, 'business_unit_id', false);
        set_total(item, 'currency_id', false);
        //IMPRIME LOS HEADERS CUANDO CAMBIA
        compare_rows(item, 'currency_id', 'currency_code', false, false);
        compare_rows(item, 'business_unit_id', 'business_unit_description', false, false);
        compare_rows(item, 'location_id', 'location_description', true, false);
        //compare_rows(item,'entity_id','entity_name',true,false);

        for (let key = 1; key <= item.amounts.length; key++) {
          totals.entity_id[key] += item.amounts[key - 1];
          totals.location_id[key] += item.amounts[key - 1];
          totals.business_unit_id[key] += item.amounts[key - 1];
          totals.currency_id[key] += item.amounts[key - 1];
        }
        let set_row = item.amounts;//ARREGLO CON LOS MONTOS EN SU RESPECTIVA COLUMNA
        const t_amount = item.amounts.reduce((accumulator, currentValue) => accumulator + currentValue, 0);//SUMA LOS MONTOS DEL ARREGLO PARA EL TOTAL
        set_row.unshift(t_amount);//AGREGA EL TOTAL AL ARREGLO DE COLUMNAS DEL EXCEL
        set_row.unshift(item.entity_name);//AGREGA EL NOMBRE AL ARREGLO DE COLUMNAS DEL EXCEL

        totals.entity_id.total += t_amount;
        totals.location_id.total += t_amount;
        totals.business_unit_id.total += t_amount;
        totals.currency_id.total += t_amount;

        const newRow = worksheet.insertRow(row, set_row);//INSERTA LA LINEA AL EXCEL
        newRow.eachCell((cell, colNumber) => {
          if (colNumber > 1) {
            cell.numFmt = accountingFormat;
          }
        });

        row++
        if (count == data.length) {
          //  set_total(item,'entity_id',true);
          set_total(item, 'location_id', true);
          set_total(item, 'business_unit_id', true);
          set_total(item, 'currency_id', true);
        }
        count++;
      }


      let total_cols = [`${titles[language].general_total}:`, base_totals.total, base_totals[1], base_totals[2], base_totals[3], base_totals[4]];
      row = row + 2;
      const newTotal = worksheet.insertRow(row, total_cols);

      newTotal.getCell(1).font = { size: 14, bold: true };
      newTotal.getCell(1).alignment = { horizontal: 'right' };
      newTotal.eachCell((cell, colNumber) => {
        if (colNumber > 1) {
          cell.numFmt = accountingFormat;
          cell.font = { size: 12, bold: true };
          cell.border = {
            bottom: { style: 'double', color: { argb: 'black' } },
          }
        }
      });
      row++
      let total_porcent_cols = [`%:`, get_porcentage(base_totals.total, base_totals.total), get_porcentage(base_totals[1], base_totals.total), get_porcentage(base_totals[2], base_totals.total), get_porcentage(base_totals[3], base_totals.total), get_porcentage(base_totals[4], base_totals.total)];
      const newTotalPorcentage = worksheet.insertRow(row, total_porcent_cols);

      newTotalPorcentage.getCell(1).font = { size: 14, bold: true };
      newTotalPorcentage.getCell(1).alignment = { horizontal: 'right' };
      newTotalPorcentage.eachCell((cell, colNumber) => {
        if (colNumber > 1) {
          cell.numFmt = '0.00\\%';
          cell.font = { size: 12, bold: true };
        }
      });


      // Write the workbook to a file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      //{{report_title.title}} {{report_title.is_default?'':report_title.union+report_title.origin+' '+report_title.date_format}}
      link.download = excel_title + ".xlsx";
      link.click();
    },
    async get_customer_account_statement() {
      const filters = this.report_filters.filters;
      try {
        let result = await this.api_Post("accounting/customer_account_statement",
          {
            location_id: filters.location ? filters.location.id : this.$store.state.auth.user.acess_locations.toString(),
            business_units: filters.business_unit.id,
            currency_type: filters.currency_type,
            include_currency_id: filters.currency_type == 2 && filters.currency.id != 0 ? true : false,
            currency_id: filters.currency.id,
            currency_code: filters.currency.code,
            date_type: filters.date_type.value,
            effective_date: filters.dateEnd,
            customer_type: filters.customer_type.id,
            entity_id: filters.entity != null ? filters.entity.entity_id : null,
            invoice_type_ids: this.aging_type == 2 ? [2, 3] : [1, 4]
          }
        );
        if (result.status == 200) {
          const data = await result.json();
          if (data.length > 0) {
            this.generate_customer_account_statement(data);
            return
          }
          this.$toast.info('No hay datos para generar el reporte');
        }
      } catch (error) {
        console.error(error.message);
        this.loading = false;
      }
    },
    async generate_customer_account_statement(data) {

      const accountingFormat = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
      const filters = this.report_filters.filters;
      const language = filters.language;

      const titles = {
        es: {
          title: "ESTADO DE CUENTA DE CLIENTES",
          date_title: 'FECHA DE DECLARACION',
          bu: 'UNIDAD DE NEGOCIOS',
          customer: 'CLIENTE',
          ship_to: 'SHIPTO',
          currency: 'MONEDA',
          invoice: 'FACTURA',
          concept: 'CONCEPTO',
          invoice_customer: 'FACTURA CLIENTE',
          payment_terms: 'TERMINOS DE PAGO',
          date: 'FECHA EMISION',
          expire_at: 'FECHA VENCIMIENTO',
          days: 'DIAS',
          days_left: 'DIAS FALTANTES',
          amount: 'MONTO',
          adjustment: 'AJUSTES',
          total: 'TOTAL',
        },
        en: {
          title: "STATEMENT OF ACCOUNT",
          date_title: 'STATEMENT DATE',
          bu: 'BUSINESS UNIT',
          customer: 'CUSTOMER',
          ship_to: 'SHIPTO',
          currency: 'CURRENCY',
          invoice: 'INVOICE',
          concept: 'CONCEPT',
          invoice_customer: 'MANIF/ISD',
          payment_terms: 'PAYMENT TERMS',
          date: 'EMISSION DATE',
          expire_at: 'EXPIRE DATE',
          days: 'DAYS',
          days_left: 'DAYS OVERDUE',
          amount: 'AMOUNT',
          adjustment: 'ADJUSTMENT',
          total: 'TOTAL',
        }
      }
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(titles[language].title);

      const titleA = worksheet.insertRow(1, ['GRUPO M']);
      worksheet.mergeCells('A1:O1');
      titleA.getCell(1).font = { size: 15, bold: true };
      titleA.getCell(1).alignment = { horizontal: 'center' };

      const titleB = worksheet.insertRow(2, [titles[language].title]);
      worksheet.mergeCells('A2:O2');
      titleB.getCell(1).font = { size: 15, bold: true };
      titleB.getCell(1).alignment = { horizontal: 'center' };

      const titleC = worksheet.insertRow(3, [`${titles[language].date_title}:${filters.dateEnd}`]);
      worksheet.mergeCells('A3:O3');
      titleC.getCell(1).font = { size: 15, bold: true };
      titleC.getCell(1).alignment = { horizontal: 'center' };

      const titleD = worksheet.insertRow(4, [`${titles[language].bu}: ${filters.business_unit.text}`]);
      worksheet.mergeCells('A4:O4');
      titleD.getCell(1).font = { size: 15, bold: true };
      titleD.getCell(1).alignment = { horizontal: 'center' };

      const cols = [titles[language].customer, titles[language].ship_to, titles[language].bu, titles[language].currency, titles[language].invoice, titles[language].concept, titles[language].invoice_customer, 'NCF', titles[language].payment_terms, titles[language].date, titles[language].expire_at, titles[language].days_left, titles[language].amount, titles[language].adjustment, titles[language].total];
      const columns = worksheet.insertRow(5, cols);
      for (let col = 1; col <= cols.length; col++) {
        columns.getCell(col).font = { size: 12, bold: true };
      }

      let row = 6;
      for (let item of data) {
        const set_row = [item.entity_name.toUpperCase(), '', item.business_unit_description, item.currency_code, item.invoice_number, item.note, '', item.invoice_ncf == null ? '' : item.invoice_ncf, `${item.payment_terms} ${titles[language].days}`, item.emission_date, item.expire_at, item.days < 0 ? 0 : item.days, parseFloat(item.total_amount), parseFloat(item.adjustment), parseFloat(item.total_amount) - parseFloat(item.adjustment)]

        const newRow = worksheet.insertRow(row, set_row);//INSERTA LA LINEA AL EXCEL
        newRow.eachCell((cell, colNumber) => {
          if (colNumber > 12) {
            cell.numFmt = accountingFormat;
          }
        });
        row++;
      }
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${titles[language].title} ${this.report_title.origin} ${this.report_title.date}.xlsx`;
      link.click();
    }
  },
  components: {
    HeaderFiltersReports
  },
};
</script>

<style scoped>
.glass-effect {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.border-light {
  border: 1px solid #f0f0f0 !important;
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}

.opacity-20 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.opacity-80 {
  opacity: 0.8;
}

.v-card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}
</style>